import styled from 'styled-components'
import { Link } from 'gatsby'
import { brandDarkGrey, brandIvory, brandOrange } from '../../../../assets/consts/color'
import { primaryFont, secondaryFont } from '../../../../assets/consts/fonts'

const Form = styled.form`
  display: flex;
  gap: 8px;

  @media only screen and (min-width: 82em) {
    background-color: ${brandIvory};
    padding: 12px 15px;
  }

  .field-error-message {
    display: none;
  }
`

const NewsletterHeading = styled.h2`
  margin: 0;
  font-family: ${secondaryFont};
  font-size: 22px;
  font-weight: 700;
  line-height: 1.15;
  color: ${brandDarkGrey};
  max-width: 280px;

  @media only screen and (min-width: 48em) {
    margin-top: 10px;
    font-size: 28px;
    max-width: 340px;
  }

  @media only screen and (min-width: 82em) {
    max-width: 184px;
  }

  @media only screen and (min-width: 120em) {
    max-width: 340px;
  }
`

const BodyWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  width: 100%;
  align-items: flex-start;
  flex-direction: column;

  @media only screen and (min-width: 82em) {
    flex-direction: row;
    align-items: flex-start;
    gap: 32px;
  }
`

const FormFieldsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-width: 0;
  width: 100%;
`

const InputButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 10px;
  width: 100%;

  @media only screen and (min-width: 82em) {
    gap: 20px;
  }

  & > button {
    flex-shrink: 1;
  }

  @media only screen and (max-width: 82em) {
    & > button {
      max-width: 104px;
      max-height: 40px;
      font-size: 14px;
      display: grid;
      place-content: center;

      &:after {
        display: none;
      }
    }
  }

  @media only screen and (min-width: 82em) {
    & > button {
      max-width: 220px;
      max-height: 56px;
    }
  }

  @media only screen and (max-width: 48em) {
    flex-direction: column;
    align-items: stretch;

    & > button {
      max-width: 100%;
    }
  }
`

const ConsentFieldOuter = styled.div`
  width: 100%;

  span,
  label span {
    font-size: 11px !important;
    line-height: 1.15 !important;
    color: ${brandDarkGrey};
  }

  /* .field-error-message {
    display: block;
  } */
`

const BodyInner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
  background-color: ${brandIvory};
  padding: 6px 8px;

  @media only screen and (min-width: 82em) {
    background-color: transparent;
    padding: 0;
  }
`

const EmailFieldGrow = styled.div`
  flex: 1;
  min-width: 0;
`

const PrivacyPolicyLink = styled(Link)`
  color: ${brandOrange};
  text-decoration: underline;
  font-family: ${primaryFont};

  &:hover,
  &:focus-visible {
    color: ${brandOrange};
  }
`

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 24px;
  width: 100%;

  input {
    padding-left: 12px;
    font-size: 16px;
    border-radius: 0;
  }

  span {
    font-size: 14px !important;
  }

  @media only screen and (max-width: 82em) {
    input {
      padding: 10px;
    }
  }
`

export {
  Form,
  FieldWrapper,
  BodyWrapper,
  BodyInner,
  NewsletterHeading,
  FormFieldsColumn,
  InputButtonRow,
  ConsentFieldOuter,
  EmailFieldGrow,
  PrivacyPolicyLink,
}
